export enum PassengerDeleteResultEnum {
  NewBooking = "NewBooking",
  CancelBooking = "CancelBooking",
  NoAction = "NoAction",
}
